import React, { Component } from "react";
import { Timer } from "@learningblocks/storybook-components";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../../../Dialogs/toast/Toast";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";

const toasterNotify = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
};

export const NOTIFY_EVENTS = {
  // NOT_RUNNABLE: {
  //   title: "Microcentrifuge open or not balanced!",
  //   message: "Ensure that the tubes are balanced and the lid of centrifuge is closed."
  // },
  // BALANCED: {
  //   title: "Balanced!",
  //   message: "Looks balanced."
  // },
  // NOT_BALANCED: {
  //   title: "Not balanced!",
  //   message: "Distribute the tubes evently to balance the centrifuge."
  // },
  // // WRONG_NUMBER_TUBES: {
  // //   title: "Wrong number of tubes!",
  // //   message: "Wrong number of tubes."
  // // },
  // // WRONG_NUMBER_ROTORS: {
  // //   title: "Wrong number of tubes!",
  // //   message: "Wrong number of rotors."
  // // },
  // NOT_ALLOWED_CENTRIFUGE_RUNNING: {
  //   title: "Centrifuge running!",
  //   message: "Operation not avaliable while centrifuge running."
  // },
};

export class Graphics extends Component {

  // checkBalance = () => {
  //   let tubesBalanced = this.centrifugeBalanced(this.props.slots);
  //   let rotorsBalanced = true;
  //
  //   if (rotorsBalanced && tubesBalanced) {
  //     this.props.checkMicrocentrifugeBalance({
  //       id: this.props.id,
  //       balanced: true,
  //     });
  //     // toasterNotify("HINT", NOTIFY_EVENTS.BALANCED.message, NOTIFY_EVENTS.BALANCED.title);
  //     return true;
  //   }
  // };
  //
  // centrifugeBalanced = (slots) => {
  //
  //   let numberOfSlots = slots.length;
  //   let internalAngle = (360 / numberOfSlots); // Internal angle of a single slot
  //
  //   let radius = 1; // Length from center (0,0) to a single slot (1,0)
  //   let balanceX = 0;
  //   let balanceY = 0
  //
  //   slots.map((slot, i)=>{
  //     if(slot.solution){
  //
  //       // Calculate the coordinate value for this slot (Math.sin / Math.cos require radians and not degrees)
  //       let oppositeSide = Math.sin((internalAngle * (i + 1)) * (Math.PI/180)) * radius;
  //       let adjacentSide = Math.cos((internalAngle * (i + 1)) * (Math.PI/180)) * radius;
  //
  //       // Round the values to avoid floating point errors
  //       balanceX += +oppositeSide.toFixed(3);
  //       balanceY += +adjacentSide.toFixed(3);
  //     }
  //   })
  //
  //   return (
  //     +balanceX.toFixed(3) === 0 &&
  //     +balanceY.toFixed(3) === 0
  //   );
  //
  // };

  render() {
    return (
      <Timer
        id={this.props.id}
        running={this.props.running}
        time={this.props.time}
        showPopup={this.props.showPopup}
        onClickDone={() =>
          this.props.setShowPopup({
            id: this.props.id,
            showPopup: false
          })
        }
        setShowPopup={(props) =>
          this.props.setShowPopup({
            id: this.props.id,
            showPopup: props
          })
        }
        setRunning={(props) =>
          this.props.setRunning({
            id: this.props.id
          })
        }
        setTime={(props) =>
          this.props.setTime({
            id: this.props.id,
            time: props
          })
        }
        alert={(event) => toasterNotify("WARNING", NOTIFY_EVENTS[event].message, NOTIFY_EVENTS[event].title)}
      />
    );
  }
}
